import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { getFooterContent } from '../actions/cms'
import config from '../config/cms'

const Applinks = ({ appLinks }) => {
  const dispatch = useDispatch()
  const defaultLinks = useSelector((state) => state.cms.footer?.appLinkList)
  const links = appLinks || defaultLinks

  useEffect(() => {
    if (!links) {
      dispatch(getFooterContent())
    }
  }, [dispatch, links])

  return (
    <Row className="form-row align-items-center app-links-row justify-content-center justify-content-lg-start">
      {links?.map((link) => (
        <Col xs={4} sm="auto" key={link?.id} className="text-center mt-3">
          <a target="_blank" rel="noreferrer nofollow" href={link?.link} className="text-decoration-none">
            <img
              className="img-fluid app-link-img"
              src={`${config.url}${link?.file?.url}`}
              alt={link?.file?.alternativeText}
              width={120}
              style={{
                borderRadius: '.25rem',
                border: '.125rem solid rgba(255,255,255,.5)'
              }}
            />
          </a>
        </Col>
      ))}
    </Row>
  )
}

Applinks.propTypes = {
  appLinks: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      link: PropTypes.string,
      file: PropTypes.instanceOf(Object)
    })
  )
}

export default Applinks
